import _ from "lodash";
import {
  inject,
  computed,
  defineComponent,
  ref,
  PropType,
  reactive,
  toRefs,
  watch,
  onMounted,
} from "vue";
import { message } from "ant-design-vue";
import FileStatus from "./file-status.vue";
import { FileUploadService, BizFileService } from "@/core";
import { generateUuid, getFileExt } from "@/utils";
import { FileRecord, UploadStatus } from "@/core/services/file-upload.interface";
import columns from "./attachment-table-two-constant";
import { submitSuccessEmitter } from "@/utils/emitter";

interface IState {
  uploading: boolean;
  visible: boolean;
  fileList: FileRecord[];
}
export default defineComponent({
  isGlobal: true,
  name: "Attachment",
  components: { FileStatus },
  props: {
    value: {
      type: Array as PropType<FileRecord[]>,
      default: () => [],
    },
    uploadedCount: {
      type: Number,
      default: 0,
    },
    uploadButtonText: {
      type: String,
      default: "上传附件",
    },
    maxCount: {
      type: Number,
      default: 100,
    },
    maxSize: {
      type: Number,
      default: 100, // 100M
    },
    allowEdit: {
      type: Boolean,
      default: undefined,
    },
    bizId: {
      type: String,
      require: true,
    },
    bizType: {
      type: String,
      require: true,
    },
    uploadAccess: {
      type: String,
    },
    downloadAccess: {
      type: String,
    },
    deleteAccess: {
      type: String,
    },
    class: {
      type: String,
      default: "responsive-table",
    },
  },
  emits: ["ok", "update:value"],
  setup(props, { emit }) {
    // const parentState = (inject("parentState") || {}) as any;
    const { run } = BizFileService.useCreateApi();
    const state = reactive<IState>({
      uploading: false,
      visible: false,
      fileList: [],
    });
    // const tableHeight = ref(0);
    // watch(
    //   () => parentState.tableHeight,
    //   (n) => {
    //     tableHeight.value = n-110;
    //     // // console.log("parentState.tableHeight", n);
    //   },
    //   { immediate: true }
    // );

    const maxSizeByte = computed(() => {
      return props.maxSize * 1024 * 1024;
    });

    const disabled = computed(() => {
      const rest = props.maxCount - props.uploadedCount;
      return rest <= 0;
    });

    const setFileStatus = (uid, status) => {
      state.fileList = state.fileList.map((item) => {
        if (item.uid === uid) {
          item.status = status;
        }
        return item;
      });
    };

    const setFileUrl = (uid, url) => {
      state.fileList = state.fileList.map((item) => {
        if (item.uid === uid) {
          item.url = url;
        }
        return item;
      });
    };

    const beforeUpload = (file) => {
      if (file.size > maxSizeByte.value) {
        message.warning(`单个文件不得超过${props.maxSize}M`);
        return false;
      }
      if(state.fileList.length>99){
        message.warning(`附件上传限100个`);
        return false;
      }
      // return false;
    };

    const customRequest = async ({ file }) => {
      if(state.fileList.length>99){
        message.warning(`附件上传限100个`);
        return false;
      }
      // // console.log("file", file);
      state.uploading = true;
      const fileRecord = new FileRecord();
      fileRecord.merge({
        uid: file.uid,
        name: file.name,
        suffix: getFileExt(file.name),
        size: file.size,
        url: "",
        status: UploadStatus.UPLOADING,
      });
      state.fileList.push(fileRecord);

      const url = await FileUploadService.uploadToOss(file);
      if (url) {
        setFileUrl(file.uid, url);
        setFileStatus(file.uid, UploadStatus.SUCCESS);
        emit("update:value", state.fileList);
        // // console.log("state.fileList", state.fileList);
      } else {
        setFileStatus(file.uid, UploadStatus.FAIL);
      }
      state.uploading = false;
    };

    const deleteFile = (file: FileRecord) => {
      state.fileList = state.fileList.filter((item) => item.uid !== file.uid);
      emit("update:value", state.fileList);
    };

    const openPreview = async(url: any) => {
      // console.log("url", url);
      let requestUrl_1 = 'https://preview.homedo.com/view?func=todo&format=json&src='
      let requestUrl_2 = requestUrl_1 + url
      let res:any = await BizFileService.previewApi(requestUrl_2);
      window.open(res.data.result);
    };

    const showModal = () => {
      state.visible = true;
    };

    const closeModal = () => {
      state.visible = false;
      state.fileList = [];
      emit("update:value", state.fileList);
    };

    const ok = () => {
      const _fileList = _.cloneDeep(state.fileList);
      emit("update:value", _fileList);
      const _newFileList = _fileList.filter((v) => {
        return props.value.findIndex((v1) => v1.uid === v.uid) === -1;
      });
      emit("ok", _newFileList);
      closeModal();
    };

    watch(
      () => props.value,
      (newValue) => {
        const files = newValue.map((file) => {
          file.status = UploadStatus.SUCCESS;
          if (!file.uid) {
            file.uid = generateUuid();
          }
          return file;
        });
        if (files.length) {
          state.fileList = _.cloneDeep(files);
          // // console.log("_.cloneDeep(files)", state.fileList);
        }
      },
      { immediate: true }
    );

    onMounted(() => {
      state.fileList = props.value;
      // submitSuccessEmitter.all.delete("submit-success");
      submitSuccessEmitter.off("submit-success");
      submitSuccessEmitter.on("submit-success", async (obj) => {
        state.fileList.forEach((item) => {
          item.bizId = obj.bizId;
          item.bizType = obj.bizType;
        });
        if (state.fileList.length > 0) {
          await run(state.fileList, obj.bizId, obj.bizType);
        }
        state.fileList = [];
        emit("update:value", []);
      });
    });
    return {
      ...toRefs(state),
      disabled,
      columns,
      beforeUpload,
      customRequest,
      deleteFile,
      openPreview,
      showModal,
      closeModal,
      ok,
      // tableHeight,
    };
  },
});
